export default "__VITE_ASSET__BtTia0Gb__"